exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".integrations .open-payments-logo {\n  margin: 0;\n  width: 15rem;\n  height: 10rem;\n}\n\n", ""]);

// exports
